import "core-js/modules/es6.array.is-array";
import _typeof from "@babel/runtime/helpers/esm/typeof";
export var isObject = function isObject(x) {
  return _typeof(x) === 'object' && !Array.isArray(x) && x !== null;
};